<template>
  <div class="py-4 container-fluid">
    <div v-if="!isLoading" class="row">
      <div class="col-12">
        <navbaroptions
          isBlur="blur border-radius-lg py-2 start-0 end-0 mb-3 shadow"
          v-bind:darkMode="true"
          isBtn="bg-gradient-success"
          toRoute="/slider-card/0"
        />
      </div>
      <div class="col-12">
        <argon-alert v-if="showAlert" color="danger" :dismissible="true" @close-alert="closeAlert">
          <strong>Slider!</strong> Eliminado correctamente!
        </argon-alert>
      </div>
      <div
        class="col-lg-6 col-md-6 col-12 mb-4"
        v-for="slider in sliders"
        :key="slider.id"
      >
        <!-- <router-link :to="`/Bypass`"> -->
        <sliders-table :slider="slider" />
        <!-- </router-link> -->
      </div>
    </div>
  </div>
</template>

<script>
import SlidersTable from "./components/SlidersTable.vue";
import Navbaroptions from "@/examples/PageLayout/Navbaroptions.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";

export default {
  name: "slider",
  components: { SlidersTable, Navbaroptions, ArgonAlert },
  data() {
    return {
      sliders: undefined,
      isLoading: true,
      showAlert: false,
    };
  },
  created() {
    this.plain
      .get(`/sliders`)
      .then((response) => {
        // console.log('SLIDERS TOTALES');
        // console.log(response.data);
        if (response.data.length !== 0) this.sliders = response.data;
        else this.sliders = [];
        this.isLoading = false;
      })
      .catch((err) => {
        this.sliders = [];
        this.isLoading = false;
        console.log(err);
      });
  },
  methods: {
    deleteItemSlider(sliderID) {
      this.showAlert = true
      this.sliders = this.sliders.filter(({ id }) => id !== sliderID);
      // console.log("SLIDERS SLIDERS SLIDER");
      // console.log(this.sliders);
      window.scrollTo(0, 0);
    },
    changeStatusSlider(slider) {
      let indexSlider = this.sliders.findIndex(({ id }) => id === slider.id);
      this.sliders.splice(indexSlider,1,slider);
    },
    closeAlert(){
      this.showAlert = false;
    }
  },
};
</script>
